// material-ui
import { CardActions } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import { Button, Divider, Grid, Typography } from '@mui/material'
import rq from 'components/RedQuick'
import * as SC from 'features/shared_components'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'

import { gridSpacing } from 'store/constant'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import { getUserClaims } from 'features/application/application-slice'
import { get_all_contentCreatorInvite } from 'features/contentCreatorInvite/contentCreatorInvite-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let contentCreatorInvite_list = useSelector(get_all_contentCreatorInvite)
  const [inviteArgs, setInviteArgs] = React.useState(null)
  const [email, setEmail] = React.useState(null)
  const [deleteArg, setDeleteArg] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_content_creator_invites({ ok: 'ok' }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && inviteArgs?.email) {
      dispatch(
        autoThunks.create_content_creator_invite({
          inviteArgs: (() => {
            function _(): any {
              return inviteArgs
            }
            return _()
          })(),
        }),
      )
    }
  }, [claims?.player, inviteArgs])
  useEffect(() => {
    if (claims?.player && deleteArg) {
      dispatch(
        autoThunks.delete_content_creator_invite({
          id: (() => {
            function _(): any {
              return deleteArg
            }
            return _()
          })(),
        }),
      )
    }
  }, [claims?.player, deleteArg])

  function modelComponent(): any {
    return (() => {
      if (contentCreatorInvite_list?.length === 0) {
        return <></>
      }
      return (
        <>
          <div>
            {contentCreatorInvite_list.map((invite) => {
              return (
                <>
                  <Grid key={invite?.id} container direction="column">
                    <Grid item>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Grid item>
                          <Typography variant="subtitle1" color="inherit">
                            {invite?.contentCreatorEmail}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Grid item>
                              <div
                                onClick={() => {
                                  setDeleteArg(invite?.id)
                                }}
                              >
                                <Typography variant="subtitle1" color="inherit">
                                  {TitleService('Delete')}
                                </Typography>
                              </div>
                            </Grid>
                            <Grid item></Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: theme.palette.success.dark }}
                      >
                        {SC.decipherDate(invite?.created)?.toDateString()}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )
            })}
          </div>
        </>
      )
    })()
  }

  let output_modelComponent = modelComponent()

  function main_card(modelList: any): any {
    return (
      <Grid container spacing={gridSpacing}>
        <Grid item xs={6}>
          <MainCard title={TitleService('Invites')}>{modelList}</MainCard>
        </Grid>
        <Grid item xs={6}>
          <MainCard title={TitleService('Create Invite')}>
            <Grid container direction="column" spacing={2}>
              <Grid item xs={12}>
                <rq.RedQuickTextField
                  value={email}
                  onChange={(val) => {
                    setEmail(val)
                  }}
                />
              </Grid>
            </Grid>
            <Divider />
            <CardActions sx={{ p: 1.25, justifyContent: 'center' }}>
              <Button
                onClick={() => {
                  setInviteArgs({
                    email,
                  })
                }}
              >
                {TitleService('Add')}
              </Button>
            </CardActions>
          </MainCard>
        </Grid>
      </Grid>
    )
  }

  let output_main_card = main_card(output_modelComponent)

  return output_main_card
}
